import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import './index.css'
import App from './App.tsx'
// Importem i18n (ha de ser abans de qualsevol component que utilitzi traduccions)
import './i18n.ts'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

// Interceptor global per a respostes 401 (token expirat)
const originalFetch = window.fetch
window.fetch = async (...args) => {
  const response = await originalFetch(...args)

  if (response.status === 401) {
    // Token expirat - netegem l'emmagatzematge i redirigim al login
    localStorage.removeItem('token')
    localStorage.removeItem('userRole')
    localStorage.removeItem('selectedCountry')
    localStorage.removeItem('selectedState')
    localStorage.removeItem('tempPostcode')
    localStorage.removeItem('tempCity')
    localStorage.removeItem('cartItems')

    // Redirigim al login recarregant la pàgina
    window.location.href = '/'
  }

  return response
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
)
